import api from "./api";

const BASE = "/invoice";

export const getMyInvoices = async () =>
    (await api.get(`${BASE}/my`)).data;

export const getInvoice = async (id) =>
    (await api.get(`${BASE}/${id}`)).data;

export default {
    getMyInvoices,
    getInvoice,
};